import React from 'react';

import { RoutesTableTranslations } from '../../../../routes-planner/translations';

interface Props {
	value?: string | number | boolean;
	translation: RoutesTableTranslations;
}

const CustomAttributeColumn = ({ value, translation }: Props) => {
	const getAttributeValue = value => {
		if (typeof value === 'boolean') {
			if (value) {
				return translation.yes;
			}
			return translation.no;
		}
		return `${value}`;
	};

	return <div>{value !== undefined && getAttributeValue(value)}</div>;
};

export default CustomAttributeColumn;
